import React, { useState, useEffect } from "react";
import styled from "styled-components"; // <-- Corrección: se importa styled-components
import { Link } from "react-router-dom";
import logoImage from "../assets/images/Geritage.png";
import backgroundImage from "../assets/images/HeritageBackground.png";

let hasRendered = false;

// Reservation Modal Component
const ReservationModal = ({ onClose }) => {
  return (
    <div className="reservation-modal">
      <div className="reservation-card">
        <div className="reservation-iframe-container">
          <iframe
            src="https://bookridesonline.com/book/?dbaid=27Tezv2FIvv7%2fytBuYKNdA%3d%3d"
            title="Booking Form"
            className="reservation-iframe"
          ></iframe>
          <div className="white-overlay">
            <h2 className="overlay-title">
              HERITAGE
              <br />
              CAR AIRPORT INC.
            </h2>
          </div>
        </div>
        <button className="close-btn-bottom" onClick={onClose}>
          CLOSE
        </button>
      </div>
    </div>
  );
};

// Location Modal Component
const LocationModal = ({ onClose }) => {
  return (
    <div className="location-modal">
      <div className="location-card">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3154.659293585457!2d-73.7414121!3d41.4763134!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2b7b11a6cf2e5%3A0x8a9d408a32fdf9d2!2sHeritage%20Car%20Service!5e0!3m2!1ses!2sus!4v1610000000000!5m2!1ses!2sus"
          title="Location"
          className="location-iframe"
        ></iframe>
        <button className="close-btn" onClick={onClose}>
          CLOSE
        </button>
      </div>
    </div>
  );
};

// Services Drawer Component with 20 services
// Each service button initiates an immediate call.
const ServicesDrawer = ({ isOpen, onClose }) => {
  const servicesList = [
    { id: 1, name: "Corporate Events" },
    { id: 2, name: "Airport Rides" },
    { id: 3, name: "Local Rides" },
    { id: 4, name: "Luxury Rides" },
    { id: 5, name: "Long Distance" },
    { id: 6, name: "Weddings" },
    { id: 7, name: "Proms" },
    { id: 8, name: "City Tours" },
    { id: 9, name: "Wine Tours" },
    { id: 10, name: "Cruise Port Transfers" },
    { id: 11, name: "Business Meetings" },
    { id: 12, name: "VIP Transportation" },
    { id: 13, name: "Night Outs" },
    { id: 14, name: "Casino Trips" },
    { id: 15, name: "Quinceañeras" },
    { id: 16, name: "Anniversaries" },
    { id: 17, name: "Birthday Parties" },
    { id: 18, name: "Road Shows" },
    { id: 19, name: "Sporting Events" },
    { id: 20, name: "Executive Services" },
  ];

  // Replace with your desired phone number
  const phoneNumber = "9142762961";

  return (
    <div className={`services-drawer ${isOpen ? "open" : ""}`}>
      <div className="drawer-header">
        <h2>Our Services</h2>
        <button className="drawer-close-btn" onClick={onClose}>
          &times;
        </button>
      </div>
      {/* Thin horizontal divider matching nav bar color */}
      <hr className="drawer-divider" />
      <div className="drawer-content">
        <p>Select and connect with Heritage Car Airport immediately</p>
        <ul>
          {servicesList.map((service) => (
            <li key={service.id}>
              <a className="service-item" href={`tel:${phoneNumber}`}>
                {service.name}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

const NavBar = () => {
  const [shouldRender, setShouldRender] = useState(false);
  const [isSticky, setIsSticky] = useState(false);
  const [showReservationForm, setShowReservationForm] = useState(false);
  const [showLocationModal, setShowLocationModal] = useState(false);
  const [showServicesDrawer, setShowServicesDrawer] = useState(false);

  useEffect(() => {
    if (!hasRendered) {
      hasRendered = true;
      setShouldRender(true);
    }
    const handleScroll = () => {
      setIsSticky(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  if (!shouldRender) return null;

  return (
    <>
      <style>{`
        /* Global Styles */
        body {
          margin: 0;
          padding: 0;
          font-family: sans-serif;
        }
        .nav-container {
          width: 100%;
          background: linear-gradient(to bottom, #161616 0%, #2B3F50 100%);
          box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          transition: background 0.4s ease, backdrop-filter 0.4s ease;
          position: relative;
          z-index: 10;
        }
        .nav-container.sticky {
          background: linear-gradient(to bottom, rgba(16,16,16,0.8) 0%, rgba(43,63,80,0.8) 100%);
          backdrop-filter: blur(8px);
        }
        .background-container {
          position: absolute;
          top: 100px;
          left: 0;
          width: 100%;
          height: calc(100vh - 100px);
          background: url(${backgroundImage}) no-repeat center center;
          background-size: cover;
          background-attachment: fixed;
          filter: brightness(0.9) contrast(1.2);
          z-index: 1;
          overflow: hidden;
        }
        .background-container::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3));
          pointer-events: none;
        }
        .inner-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 20px;
        }
        .header {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
        }
        .logo-container {
          position: relative;
          display: flex;
          align-items: center;
        }
        .logo {
          height: 100px;
          margin-right: 8px;
          filter: grayscale(1) brightness(1.1) contrast(1.05);
          transition: transform 0.3s ease, filter 0.3s ease;
          position: relative;
          z-index: 1;
        }
        .logo:hover {
          transform: scale(1.03);
          filter: grayscale(1) brightness(1.2) contrast(1.1);
        }
        .logo-container::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(to bottom, #161616, #2B3F50);
          mix-blend-mode: color;
          pointer-events: none;
          z-index: 2;
        }
        .nav-container.sticky .logo-container::after {
          display: none;
        }
        .logo-text h1 {
          margin: 0;
          font-size: 24px;
          line-height: 1;
          color: #ffffff;
          font-family: 'Georgia', serif;
        }
        .logo-text p {
          margin: 0;
          font-size: 12px;
          letter-spacing: 1px;
          color: #ffffff;
          font-family: 'Arial', sans-serif;
        }
        .contact-info span {
          font-weight: bold;
          color: #ffffff;
        }
        .nav-bar {
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(to bottom, #161616 0%, #2B3F50 100%);
          padding: 10px 0;
          transition: background 0.3s ease;
        }
        .nav-bar.sticky {
          background: transparent;
        }
        .nav-bar ul {
          list-style: none;
          display: flex;
          margin: 0;
          padding: 0;
        }
        .nav-bar li {
          margin-right: 20px;
        }
        .nav-bar li a,
        .nav-bar li button {
          text-decoration: none;
          color: #ffffff;
          font-weight: 500;
          background: none;
          border: none;
          cursor: pointer;
          font-size: inherit;
          font-family: inherit;
        }
        .nav-buttons {
          display: flex;
          gap: 10px;
        }
        .quote-btn,
        .reservation-btn {
          padding: 8px 16px;
          border: none;
          cursor: pointer;
          font-weight: 600;
          transition: background-color 0.2s ease;
        }
        .quote-btn {
          background-color: #0066cc;
          color: #ffffff;
        }
        .quote-btn:hover {
          background-color: #0055aa;
        }
        .reservation-btn {
          background-color: #333333;
          color: #ffffff;
        }
        .reservation-btn:hover {
          background-color: #555555;
        }
        .logo-overlay {
          position: absolute;
          top: 50%;
          left: 3cm;
          transform: translate(0, -50%);
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          z-index: 2;
          perspective: 500px;
        }
        .overlay-text {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          transform: translateZ(20px);
        }
        .overlay-text h1,
        .overlay-text p {
          margin: 0;
          color: #ffffff;
          text-shadow: 2px 2px 3px rgba(0,0,0,0.7),
                       -2px -2px 3px rgba(0,0,0,0.7),
                       4px 4px 5px rgba(0,0,0,0.5);
        }
        .overlay-text h1 {
          font-size: 50px;
        }
        .separator {
          width: 100%;
          height: 4px;
          background: #ffffff;
          margin: 8px 0;
          box-shadow: 0px 0px 10px rgba(255,255,255,0.8);
        }
        .overlay-text p {
          font-size: 24px;
          font-family: 'Arial', sans-serif;
        }
        .call-button {
          position: fixed;
          bottom: 20px;
          right: 20px;
          background-color: #28a745;
          color: #fff;
          padding: 14px 20px;
          border-radius: 40px;
          box-shadow: 0 4px 8px rgba(0,0,0,0.3);
          font-size: 16px;
          font-weight: bold;
          border: none;
          cursor: pointer;
          transition: background-color 0.2s ease, transform 0.2s ease;
          z-index: 999;
        }
        .call-button:hover {
          background-color: #218838;
          transform: scale(1.05);
        }

        /* Reservation Modal Styles */
        .reservation-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: flex-end;
          align-items: center;
          z-index: 1000;
        }
        .reservation-card {
          background: #fff;
          padding: 20px 15px;
          border-radius: 8px;
          width: 400px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          position: relative;
          text-align: center;
          margin-right: 20px;
        }
        .reservation-iframe-container {
          position: relative;
          width: 100%;
          height: 500px;
          overflow: hidden;
          border: 1px solid #ddd;
          border-radius: 8px;
        }
        .reservation-iframe {
          width: 100%;
          height: 100%;
          border: none;
          border-radius: 8px;
        }
        .white-overlay {
          position: absolute;
          top: -120px;
          left: 0;
          width: 100%;
          height: 300px;
          background: #fff;
          z-index: 2;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
        }
        .overlay-title {
          margin: 0;
          font-size: 24px;
          font-weight: bold;
          color: #333;
          text-align: center;
          line-height: 1.2;
        }
        .close-btn-bottom {
          display: inline-block;
          margin-top: 15px;
          background: #0066cc;
          border: none;
          border-radius: 8px;
          padding: 10px 16px;
          font-size: 18px;
          cursor: pointer;
          color: #fff;
          transition: background-color 0.2s ease;
        }
        .close-btn-bottom:hover {
          background-color: #005bb5;
        }

        /* Location Modal Styles */
        .location-modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: rgba(0,0,0,0.5);
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding-top: 100px;
          z-index: 1000;
        }
        .location-card {
          background: #fff;
          padding: 20px;
          border-radius: 8px;
          width: 40%;
          max-width: 600px;
          box-shadow: 0 4px 12px rgba(0,0,0,0.3);
          text-align: center;
        }
        .location-iframe {
          width: 100%;
          height: 400px;
          border: none;
          border-radius: 8px;
        }
        .close-btn {
          margin-top: 15px;
          background: #0066cc;
          border: none;
          border-radius: 8px;
          padding: 10px 16px;
          font-size: 18px;
          cursor: pointer;
          color: #fff;
          transition: background-color 0.2s ease;
        }
        .close-btn:hover {
          background-color: #005bb5;
        }

        /* Services Drawer Styles (Elegant with Transparency and Outline) */
        .services-drawer {
          position: fixed;
          top: 0;
          left: 0;
          width: 260px;
          height: 100%;
          background: rgba(255, 255, 255, 0.92);
          border: 1px solid #2B3F50;
          box-shadow: 2px 0 12px rgba(0, 0, 0, 0.3);
          transform: translateX(-100%);
          transition: transform 0.3s ease;
          z-index: 1001;
          display: flex;
          flex-direction: column;
          backdrop-filter: brightness(1.05);
        }
        .services-drawer.open {
          transform: translateX(0);
        }
        .drawer-header {
          background: rgba(248, 248, 248, 0.95);
          border-bottom: 1px solid #ddd;
          padding: 16px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        .drawer-header h2 {
          margin: 0;
          font-size: 18px;
        }
        .drawer-close-btn {
          background: none;
          border: none;
          font-size: 24px;
          cursor: pointer;
          line-height: 1;
        }
        /* Thin horizontal divider styled as the nav bar */
        .drawer-divider {
          border: 0;
          height: 1px;
          background: #2B3F50;
          margin: 0;
        }
        .drawer-content {
          padding: 16px;
          overflow-y: auto;
          flex: 1;
        }
        .drawer-content p {
          margin-top: 0;
          font-weight: bold;
        }
        .drawer-content ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        .drawer-content li {
          margin-bottom: 10px;
        }
        .service-item {
          width: 100%;
          background: #0066cc;
          color: #fff;
          border: none;
          padding: 8px;
          border-radius: 4px;
          cursor: pointer;
          text-align: left;
          text-decoration: none;
          display: block;
          transition: background-color 0.2s ease;
        }
        .service-item:hover {
          background: #005bb5;
        }
      `}</style>

      {/* NAVBAR */}
      <div className={`nav-container ${isSticky ? "sticky" : ""}`}>
        <div className="inner-container">
          <div className="header">
            <div className="logo-container">
              <img
                src={logoImage}
                alt="Heritage Car Airport Inc. Logo"
                className="logo"
              />
              <div className="logo-text">
                <h1>HERITAGE</h1>
                <p>CAR AIRPORT INC.</p>
              </div>
            </div>
            <div className="contact-info">
              <span>CALL OR TEXT NOW +19142762961</span>
            </div>
          </div>

          <div className={`nav-bar ${isSticky ? "sticky" : ""}`}>
            <ul>
              <li>
                <Link to="/">HOME</Link>
              </li>
              <li>
                <Link to="/info">ABOUT</Link>
              </li>
              <li>
                <Link to="/fleet">FLEET</Link>
              </li>
              {/* Button to open Services Drawer */}
              <li>
                <button onClick={() => setShowServicesDrawer(true)}>SERVICES</button>
              </li>
              <li>
                <button onClick={() => setShowLocationModal(true)}>LOCATIONS</button>
              </li>
            </ul>
            <div className="nav-buttons">
              <button className="quote-btn">FREE QUOTE NOW</button>
              <button
                className="reservation-btn"
                onClick={() => setShowReservationForm(true)}
              >
                MAKE A RESERVATION
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* BACKGROUND */}
      <div className="background-container">
        <div className="logo-overlay">
          <div className="overlay-text">
            <h1>HERITAGE</h1>
            <div className="separator"></div>
            <p>CAR AIRPORT INC.</p>
          </div>
        </div>
      </div>

      {/* CALL BUTTON */}
      <a href="tel:+19142762961" className="call-button">
        CALL NOW
      </a>

      {/* MODALS */}
      {showReservationForm && (
        <ReservationModal onClose={() => setShowReservationForm(false)} />
      )}
      {showLocationModal && (
        <LocationModal onClose={() => setShowLocationModal(false)} />
      )}
      {/* SERVICES DRAWER */}
      <ServicesDrawer
        isOpen={showServicesDrawer}
        onClose={() => setShowServicesDrawer(false)}
      />
    </>
  );
};

export default NavBar;
